export default function TextFont (pButton)
{
  this.createTextFontDropdownButton = () =>
  {
    pButton.eButtonText = pButton.pGroup.pToolbar.tDoc.createElement('DIV');
    pButton.eButtonText.setAttribute('style', 'position: absolute; left: 0px; top: 0px; z-index: 7; width: ' + (pButton.pAttribute.width - 24) + 'px; height: ' + pButton.pAttribute.height + 'px; overflow: hidden; margin-right: 17px; padding: 7px 0px 0px 7px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; font-style: normal; color: #C1C1C1; white-space: nowrap;');
    pButton.eButtonText.innerHTML = pButton.pAttribute.title;

    pButton.eButton.appendChild(pButton.eButtonText);
  };


  this.preInitTextFontDropdownButton = (isNewTheme) =>
  {
    const isPublic = (pButton.pAttribute.name.indexOf('Public') !== -1),
          textFonts = pButton.pAttribute.parameters.textFonts,
          len = textFonts.length;

    let dropdownInnerHTML;

    pButton.pAttribute.parameters.dropdownItemsLenght = len;

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: ' + (isPublic ? '182' : '190') + 'px; padding: 5px 0; background-color: #F5F5F5;">';

    for (let i = 0; i < len; i++)
    {
      dropdownInnerHTML += '<div id="idItemsContainer_' + i + '" style="position: relative; width: ' + (isPublic ? '159' : '167') + 'px; overflow: hidden; padding: 5px 12px 5px 11px; font-family: ' + textFonts[i]['font'] + '; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
      dropdownInnerHTML += '  <div style="width: ' + (isPublic ? '159' : '167') + 'px; overflow: hidden; white-space: nowrap;">';
      dropdownInnerHTML +=      textFonts[i]['name'];
      dropdownInnerHTML += '  </div>';
      dropdownInnerHTML += '  <div ddtype="Item" ddvalue="' + textFonts[i]['font'] + '" style="position: absolute; top: 0; left: 0; width: ' + (isPublic ? '180' : '188') + 'px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: ' + ((BEditor.browser.isIE) ? 'hand' : 'pointer') + ';"></div>';
      dropdownInnerHTML += '</div>';
    }

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML, null, null, null, null, null, { 'isReload': !!isNewTheme });
    pButton.initDropdownComponents();
  };
}